import styled from 'styled-components';

export const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: max-content;

  &:after {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 50%;
    right: 8px;
    width: 12px;
    height: 12px;
    margin-top: -6px;
    background: url(/images/icons/caretDown.svg) no-repeat center;
    background-size: contain;
}
  }
`;

export const Select = styled.select`
  border-radius: 8px;
  font-size: 16px;
  padding: 8px 24px 8px 8px;
  background-color: #3d3c41;
  border: none;
  color: #edeff5;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  &:focus {
    outline: none;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
`;
